import React from 'react';
import { IonToast, IonIcon } from '@ionic/react';
import { cloudOfflineOutline, alertCircleOutline } from 'ionicons/icons';
import './OfflineNotification.css';

interface OfflineNotificationProps {
  isOpen: boolean;
  onDidDismiss: () => void;
  message?: string;
  duration?: number;
  actionName?: string;
}

const OfflineNotification: React.FC<OfflineNotificationProps> = ({
  isOpen,
  onDidDismiss,
  message = 'Esta acción no está disponible sin conexión a internet',
  duration = 3000,
  actionName
}) => {
  // Mensaje personalizado según el tipo de acción
  let displayMessage = message;

  if (!displayMessage && actionName) {
    // Mensajes específicos para ciertas acciones
    if (actionName === 'dar "me gusta"') {
      displayMessage = 'No puedes dar "me gusta" sin conexión a internet. Tus interacciones se guardarán cuando vuelvas a estar en línea.';
    } else if (actionName === 'enviar preguntas') {
      displayMessage = 'No puedes enviar preguntas sin conexión a internet. Tus preguntas se guardarán cuando vuelvas a estar en línea.';
    } else if (actionName === 'comentar') {
      displayMessage = 'No puedes comentar sin conexión a internet. Tus comentarios se guardarán cuando vuelvas a estar en línea.';
    } else {
      // Mensaje genérico para otras acciones
      displayMessage = `No se puede ${actionName} sin conexión a internet`;
    }
  }

  return (
    <IonToast
      isOpen={isOpen}
      onDidDismiss={onDidDismiss}
      message={displayMessage}
      position="bottom"
      color="warning"
      duration={duration}
      cssClass="offline-notification"
      buttons={[
        {
          text: 'OK',
          role: 'cancel',
          handler: () => {
            onDidDismiss();
          }
        }
      ]}
      icon={cloudOfflineOutline}
    />
  );
};

// Componente para mostrar un botón deshabilitado en modo offline
export const OfflineDisabledButton: React.FC<{
  isOnline: boolean;
  onClick: () => void;
  onOfflineClick?: () => void;
  className?: string;
  children: React.ReactNode;
}> = ({ isOnline, onClick, onOfflineClick, className = '', children }) => {
  const handleClick = () => {
    if (isOnline) {
      onClick();
    } else {
      if (onOfflineClick) {
        onOfflineClick();
      }
    }
  };

  return (
    <button
      className={`${className} ${!isOnline ? 'offline-disabled' : ''}`}
      onClick={handleClick}
      disabled={!isOnline}
    >
      {children}
      {!isOnline && (
        <span className="offline-indicator">
          <IonIcon icon={cloudOfflineOutline} />
        </span>
      )}
    </button>
  );
};

export default OfflineNotification;
